if (!customElements.get('media-gallery')) {
  class MediaGallery extends HTMLElement {
    constructor() {
      super();

      if (Shopify.designMode) {
        setTimeout(() => this.init(), 200);
      } else {
        this.init();
      }
    }

    disconnectedCallback() {
      window.removeEventListener('on:debounced-resize', this.resizeHandler);

      if (this.resizeInitHandler) {
        window.removeEventListener('on:debounced-resize', this.resizeInitHandler);
      }

      if (this.zoomInitHandler) {
        window.removeEventListener('on:debounced-resize', this.zoomInitHandler);
      }
    }

    init() {
      this.section = this.closest('.js-product');
      this.mediaGroupingEnabled = this.hasAttribute('data-media-grouping-enabled')
        && this.getMediaGroupData();
      this.stackedScroll = this.dataset.stackedScroll;
      this.stackedUnderline = this.dataset.stackedUnderline === 'true' && !this.mediaGroupingEnabled;
      this.isFeatured = this.dataset.isFeatured === 'true';
      this.viewer = this.querySelector('.media-viewer');
      this.thumbs = this.querySelector('.media-thumbs');
      this.thumbsItems = this.querySelectorAll('.media-thumbs__item');
      this.controls = this.querySelector('.media-ctrl');
      this.prevBtn = this.querySelector('.media-ctrl__btn[name="prev"]');
      this.nextBtn = this.querySelector('.media-ctrl__btn[name="next"]');
      this.thumbsControls = this.querySelector('.media-thumbs-ctrl');
      this.thumbsPrevBtn = this.querySelector('.media-thumbs-ctrl__btn[name="prev"]');
      this.thumbsNextBtn = this.querySelector('.media-thumbs-ctrl__btn[name="next"]');
      this.counterCurrent = this.querySelector('.media-ctrl__current-item');
      this.counterTotal = this.querySelector('.media-ctrl__total-items');
      this.liveRegion = this.querySelector('.media-gallery__status');
      this.zoomLinks = this.querySelectorAll('.js-zoom-link');
      this.loadingSpinner = this.querySelector('.loading-spinner');
      this.xrButton = this.querySelector('.media-xr-button');

      if (this.mediaGroupingEnabled) {
        this.setActiveMediaGroup(this.getMediaGroupFromOptionSelectors());
      }

      if (this.dataset.layout === 'stacked' && theme.mediaMatches.md) {
        this.resizeInitHandler = this.resizeInitHandler || this.initGallery.bind(this);
        window.addEventListener('on:debounced-resize', this.resizeInitHandler);
        this.setVisibleItems();

        if (!theme.mediaMatches.sm) {
          this.cloneSlidesForLoop();
          this.setVisibleItems();
        }

        this.previousMediaItem = this.querySelector('.media-viewer__item.is-current-variant');
        setTimeout(() => this.customSetActiveMedia(this.previousMediaItem, this.stackedScroll === 'always'), 200);
      } else {
        this.initGallery();
      }

			if (this.prevBtn) {
				this.prevBtn.disabled = theme.mediaMatches.sm;
			}

      if (this.zoomLinks) {
        this.zoomInitHandler = this.zoomInitHandler || this.initZoom.bind(this);
        this.zoomEventListener = this.zoomEventListener || this.handleZoomMouseMove.bind(this);
        window.addEventListener('on:debounced-resize', this.zoomInitHandler);
        this.initZoom();
        this.zoomLinks.forEach((el) => {
          el.addEventListener('click', (evt) => {
            evt.preventDefault();
          });
        });
      }

      this.section.addEventListener('on:variant:change', this.onVariantChange.bind(this));
    }

    /**
     * Handle a change in variant on the page.
     * @param {Event} evt - variant change event dispatched by variant-picker
     */
    onVariantChange(evt) {
      if (this.mediaGroupingEnabled) {
        this.setActiveMediaGroup(this.getMediaGroupFromOptionSelectors());
      }

      if (evt.detail.variant && evt.detail.variant.featured_media) {
        const variantMedia = this.viewer.querySelector(
          `[data-media-id="${evt.detail.variant.featured_media.id}"]`
        );
        // this.customSetActiveMedia(variantMedia, true);
      }
    }

    /**
     * Gets the media group from currently selected variant options.
     * @returns {?object}
     */
    getMediaGroupFromOptionSelectors() {
      const optionSelectors = this.section.querySelectorAll('.option-selector');
      const product_id = this.section.querySelector('variant-picker').getAttribute('data-product-id');
      if (optionSelectors.length > this.getMediaGroupData().groupOptionIndex) {
        if (optionSelectors.length > this.getMediaGroupData().groupOptionIndex_2 && optionSelectors.length > this.getMediaGroupData().groupOptionIndex_2) {
          const selector = optionSelectors[this.getMediaGroupData().groupOptionIndex];
          const selector_2 = optionSelectors[this.getMediaGroupData().groupOptionIndex_2];

          if (selector.dataset.selectorType === 'dropdown') {
            return selector.querySelector('.custom-select__btn').textContent.trim() + ' / ' + selector_2.querySelector('.custom-select__btn').textContent.trim();
          }

          return product_id + ' / ' + selector.querySelector('input:checked').value + ' / ' + selector_2.querySelector('input:checked').value;
        } else {
          const selector = optionSelectors[this.getMediaGroupData().groupOptionIndex];
          if (selector.dataset.selectorType === 'dropdown') {
            return selector.querySelector('.custom-select__btn').textContent.trim();
          }
          return product_id + ' / ' + selector.querySelector('input:checked').value;
        }
      }
      return null;
    }

    /**
     * Gets the variant media associations for a product.
     * @returns {?object}
     */
    getMediaGroupData() {
      if (typeof this.variantMediaData === 'undefined') {
        const dataEl = this.querySelector('.js-data-variant-media');
        this.variantMediaData = dataEl ? JSON.parse(dataEl.textContent) : false;
      }

      return this.variantMediaData;
    }

    /**
     * Gets an object mapping media to groups, and the reverse
     * @returns {?object}
     */
    getMediaGroupMap() {
      if (!this.mediaGroupMap) {
        this.mediaGroupMap = {
          groups: {}
        };

        // set up grouping
        const variantMediaData = this.getMediaGroupData();
        // console.log('variantMediaData', variantMediaData);

        let currentMediaOptionName = false;
        this.viewerItems = this.querySelectorAll('.media-viewer__item');
        this.viewerItems.forEach((item) => {
          for (let i = 0; i < variantMediaData.variantMedia.length; i += 1) {
            if (parseInt(item.dataset.mediaId, 10) === variantMediaData.variantMedia[i].mediaId && parseInt(item.dataset.productId) === parseInt(variantMediaData.variantMedia[i].productId)) {
              if (variantMediaData.variantMedia[i].option_group_2) {
                let current_option_name = variantMediaData.variantMedia[i].productId + ' / ' + variantMediaData.variantMedia[i].option_group + ' / ' + variantMediaData.variantMedia[i].option_group_2;
                if (currentMediaOptionName !== current_option_name) {
                  currentMediaOptionName = current_option_name;
                  break;
                }
              } else {
                if (currentMediaOptionName !== variantMediaData.variantMedia[i].productId + ' / ' + variantMediaData.variantMedia[i].option_group) {
                  currentMediaOptionName = variantMediaData.variantMedia[i].productId + ' / ' + variantMediaData.variantMedia[i].option_group;
                }
              }
            }
          }
          if (currentMediaOptionName) {
            if (!this.mediaGroupMap.groups[currentMediaOptionName]) {
              this.mediaGroupMap.groups[currentMediaOptionName] = {
                name: currentMediaOptionName,
                items: []
              };
            }
            const groupItem = { main: item };
            if (this.thumbs) {
              groupItem.thumb = this.thumbs.querySelector(
                `[data-media-id="${item.dataset.mediaId}"][data-product-id="${item.dataset.productId}"].media-thumbs__item`
              );
            }
            this.mediaGroupMap.groups[currentMediaOptionName].items.push(groupItem);
          }
        });

        // add helper
        this.mediaGroupMap.groupFromItem = (item) => {
          const groups = Object.keys(this.mediaGroupMap.groups);
          for (let i = 0; i < groups; i += 1) {
            const group = groups[i];
            for (let j = 0; j < this.mediaGroupMap.groups[group].items.length; j += 1) {
              if (this.mediaGroupMap.groups[group].items[j] === item) {
                return this.mediaGroupMap.groups[group];
              }
            }
          }
          return this.mediaGroupMap.groups[Object.keys(this.mediaGroupMap.groups)[0]];
        };
      }

      // console.log('mediaGroupMap', this.mediaGroupMap);

      return this.mediaGroupMap;
    }

    /**
     * Show only images associated to the current variant
     * @param {string} groupName - optional - Group to show (uses this.currentItem if empty)
     */
    setActiveMediaGroup(groupName) {
      if (!theme.mediaMatches.sm) {
        this._loopInitialized = false;
      }

      const mediaGroupMap = this.getMediaGroupMap();
      const selectedGroup = groupName
        ? mediaGroupMap.groups[groupName]
        : mediaGroupMap.groupFromItem(this.currentItem);

      if (selectedGroup) {
        if (this.currentGroup !== selectedGroup) {
          this.currentGroup = selectedGroup;
          this.viewerItems.forEach((item) => {
            item.style.display = 'none';
            item.classList.remove('media-viewer__item--single');
          });
          this.thumbsItems.forEach((item) => {
            item.style.display = 'none';
          });

          let currentItemIsVisible = false;
          selectedGroup.items.forEach((item) => {
            item.main.style.display = '';
            if (item.thumb) {
              item.thumb.style.display = '';
            }
            if (item.main === this.currentItem) {
              currentItemIsVisible = true;
            }
          });
					
          this.viewer.querySelectorAll('.media-viewer__item--clone').forEach((clone) => {
            clone.remove();
          });
          this.setVisibleItems();
          this.setVisibleThumbsItems();

          if (!theme.mediaMatches.sm) {
            this._loopInitialized = false;
            this.cloneSlidesForLoop();
            this.setVisibleItems();
          }
	        
          // If current item is not in this group, set it as the active item
          if (!currentItemIsVisible) {
            this.customSetActiveMedia(selectedGroup.items[0].main, true);
          }

          // Handle single images on stacked view
          if (selectedGroup.items.length === 1) {
            selectedGroup.items[0].main.classList.add('media-viewer__item--single');
          }
        }
      } else {
        this.viewerItems.forEach((item) => {
          item.style.display = '';
        });
        this.thumbsItems.forEach((item) => {
          item.style.display = '';
        });
      }
    }

    /**
     * Initialises the media gallery slider and associated controls.
     */
    initGallery() {
      this.setVisibleItems();
      this.setVisibleThumbsItems();
      this.thumbs && this.setThumbsHeight();
      if (this.visibleItems.length <= 1) return;

      this.viewerItemOffset = this.visibleItems[1].offsetLeft - this.visibleItems[0].offsetLeft;
      this.currentIndex = Math.round(this.viewer.scrollLeft / this.viewerItemOffset);
      this.currentItem = this.visibleItems[this.currentIndex];

      if (this.visibleThumbsItems.length > 0) {
        this.thumbItemOffset = this.visibleThumbsItems[1].offsetTop - this.visibleThumbsItems[0].offsetTop;
        this.currentThumbIndex = Math.round(this.thumbs.scrollTop / this.thumbItemOffset);
        this.currentThumbItem = this.visibleThumbsItems[this.currentThumbIndex];
      }

      this.addListeners();

      if (this.thumbs && this.currentItem) {
        this.currentThumb = this.thumbs.querySelector(
          `[data-media-id="${this.currentItem.dataset.mediaId}"][data-product-id="${this.currentItem.dataset.productId}"]`
        );
      }

      if (!this.isFeatured && document.hasFocus()) {
        // Eager load the slider images for smooth UX
        this.viewer.querySelectorAll('.product-image[loading="lazy"]').forEach((img, index) => {
          setTimeout(() => {
            img.loading = 'eager';
          }, 500 * (index + 1));
        });
      }

      const currentItem = this.querySelector('.media-viewer__item.is-current-variant');
      this.customSetActiveMedia(currentItem, true);

      /*if (this.mediaGroupingEnabled) {
        this.setActiveMediaGroup(this.getMediaGroupFromOptionSelectors());
      }*/

      if ('requestIdleCallback' in window) {
        requestIdleCallback(() => {
          this.loadSiblingMediaInBackground();
        });
      } else {
        setTimeout(() => {
          this.loadSiblingMediaInBackground();
        }, 1500);
      }
    }

    cloneSlidesForLoop() {
      const viewer = this.viewer;

      // viewer.querySelectorAll('.media-viewer__item--clone').forEach((clone) => {
      //   clone.remove();
      // });

      const items = Array.from(this.visibleItems);
      if (items.length <= 1 || this._loopInitialized) return;

      const firstItem = items[0];
      const firstItemId = firstItem.getAttribute('data-media-id');
      if (this.viewer.querySelector('.media-viewer__item--clone[data-media-id="' + firstItemId + '"]')) return;

      const lastItem = items[items.length - 1];
      const lastItemId = lastItem.getAttribute('data-media-id');
      if (this.viewer.querySelector('.media-viewer__item--clone[data-media-id="' + lastItemId + '"]')) return;

      const first = firstItem.cloneNode(true);
      const last = lastItem.cloneNode(true);

      first.classList.add('media-viewer__item--clone');
      last.classList.add('media-viewer__item--clone');

      viewer.appendChild(first);
      viewer.insertBefore(last, viewer.firstChild);

      this._loopInitialized = true;
    }


    addListeners() {
      this.viewer.addEventListener('scroll', this.handleScroll.bind(this));
	  this.thumbs && this.thumbs.addEventListener('scroll', this.handleScrollThumb.bind(this));

      if (this.controls) this.controls.addEventListener('click', this.handleNavClick.bind(this));
      if (this.thumbsControls) this.thumbsControls.addEventListener('click', this.handleNavThumbsClick.bind(this));

      if (this.thumbs) this.thumbs.addEventListener('click', this.handleThumbClick.bind(this));
      this.resizeHandler = this.resizeHandler || this.handleResize.bind(this);
      window.addEventListener('on:debounced-resize', this.resizeHandler);
	  this.thumbs && window.addEventListener('resize', this.setThumbsHeight.bind(this));
    }

    /**
     * Initialized the zoom on hover for desktop
     */
    initZoom() {
      this.zoomLinks.forEach((el) => {
        const zoomWidth = Number(el.querySelector('.zoom-image').dataset.originalWidth || 0);

        if (!el.querySelector('.product-image')) return;

        const imageWidth = el.querySelector('.product-image').getBoundingClientRect().width;
        if (theme.mediaMatches.md && ((zoomWidth - 75) > (imageWidth))) {
          el.addEventListener('mousemove', this.zoomEventListener);
          el.classList.remove('pointer-events-none');
        } else {
          el.removeEventListener('mousemove', this.zoomEventListener);
          el.classList.add('pointer-events-none');
        }
      });
    }

    /**
     * Handles mouse move over a zoomable image
     * @param {?object} evt - Event object.
     */
    handleZoomMouseMove(evt) {
      const hoverElem = evt.currentTarget;
      const zoomImage = hoverElem.querySelector('.js-zoom-image');

      // Download the zoom image if necessary
      if (zoomImage.dataset.src) {
        this.loadingSpinner.classList.remove('loading-spinner--out');

        const img = new Image();
        img.src = zoomImage.dataset.src;
        img.onload = () => {
          zoomImage.src = img.src;
          hoverElem.classList.remove('media--zoom-not-loaded');
          this.loadingSpinner.classList.add('loading-spinner--out');
        };
        zoomImage.removeAttribute('data-src');
      }

      try {
        const offsetX = evt.offsetX ? evt.offsetX : evt.touches[0].pageX;
        const offsetY = evt.offsetY ? evt.offsetY : evt.touches[0].pageY;
        const x = (offsetX / zoomImage.offsetWidth) * 100;
        const y = (offsetY / zoomImage.offsetHeight) * 100;
        zoomImage.style.objectPosition = `${x}% ${y}%`;
      } catch (err) {
        // Fail silently
      }
    }

    /**
     * Handles 'scroll' events on the main media container.
     */
    handleScroll() {
      const newIndex = Math.round(this.viewer.scrollLeft / this.viewerItemOffset);

      if (!theme.mediaMatches.sm) {
        if (newIndex === 0) {
          setTimeout(() => {
            this.viewer.style.scrollBehavior = 'auto';
            this.viewer.scrollLeft = this.visibleItems[this.visibleItems.length - 2].offsetLeft;
            this.viewer.style.scrollBehavior = '';
            this.currentItem = this.visibleItems[this.currentIndex];
            if (this.counterCurrent) {
              const nonCloneItems = this.visibleItems.filter(item => !item.classList.contains('media-viewer__item--clone'));
              this.counterCurrent.textContent = nonCloneItems.length;
            }
          }, 300);
          return;
        }

        if (newIndex === this.visibleItems.length - 1) {
          setTimeout(() => {
            this.viewer.style.scrollBehavior = 'auto';
            this.viewer.scrollLeft = this.visibleItems[1].offsetLeft;
            this.viewer.style.scrollBehavior = '';
            this.currentIndex = 1;
            this.currentItem = this.visibleItems[this.currentIndex];

            if (this.counterCurrent) {
              this.counterCurrent.textContent = 1;
            }
          }, 300);
          return;
        }
      }

      if (newIndex !== this.currentIndex) {
        const viewerItemOffset = this.visibleItems[1].offsetLeft - this.visibleItems[0].offsetLeft;

        // If scroll wasn't caused by a resize event, update the active media.
        if (viewerItemOffset === this.viewerItemOffset) {
          this.customSetActiveMedia(this.visibleItems[newIndex], false);
          MediaGallery.playActiveMedia(this.visibleItems[newIndex]);
        }
      }
    }

    handleScrollThumb() {
      const newIndex = Math.round(this.thumbs.scrollTop / this.thumbItemOffset);

      if (newIndex !== this.currentIndex) {
        const thumbItemOffset = this.visibleThumbsItems[1].offsetTop - this.visibleThumbsItems[0].offsetTop;

        // If scroll wasn't caused by a resize event, update the active media.
        if (thumbItemOffset === this.thumbItemOffset) {
          this.currentThumbIndex = newIndex;
        }
      }
    }

    /**
     * Handles 'click' events on the controls container.
     * @param {object} evt - Event object.
     */
    handleNavClick(evt) {
      if (!evt.target.matches('.media-ctrl__btn')) return;

      let itemToShow;

      if (theme.mediaMatches.sm) {
        itemToShow = evt.target === this.nextBtn
          ? this.visibleItems[this.currentIndex + 1]
          : this.visibleItems[this.currentIndex - 1];
      } else {
        const isNext = evt.target === this.nextBtn;
        let nextIndex = this.currentIndex + (isNext ? 1 : -1);

        if (nextIndex >= this.visibleItems.length) {
          nextIndex = 0;
        } else if (nextIndex < 0) {
          nextIndex = this.visibleItems.length - 1;
        }

        itemToShow = this.visibleItems[nextIndex];
      }

      this.viewer.scrollTo({ left: itemToShow.offsetLeft, behavior: 'smooth' });
    }

    handleNavThumbsClick(evt) {
      if (!evt.target.matches('.media-thumbs-ctrl__btn')) return;

      this.currentThumbIndex = evt.target === this.thumbsNextBtn
          ? this.currentThumbIndex + 1
          : this.currentThumbIndex - 1;

      const itemToShow = this.visibleThumbsItems[this.currentThumbIndex];

      this.thumbs.scrollTo({ top: itemToShow.offsetTop, behavior: 'smooth' });
    }

    /**
     * Handles 'click' events on the thumbnails container.
     * @param {object} evt - Event object.
     */
    handleThumbClick(evt) {
      const thumb = evt.target.closest('[data-media-id]');
      if (!thumb) return;

      const itemToShow = this.viewer.querySelector(`[data-media-id="${thumb.dataset.mediaId}"][data-product-id="${thumb.dataset.productId}"]`);
			this.customSetActiveMedia(itemToShow);

      MediaGallery.playActiveMedia(itemToShow);
    }

    /**
     * Handles debounced 'resize' events on the window.
     */
    handleResize() {
      // Reset distance from leading edge of one slide to the next.
      this.viewerItemOffset = this.visibleItems[1].offsetLeft - this.visibleItems[0].offsetLeft;

      if (this.thumbs && this.currentThumb) {
        this.checkThumbVisibilty(this.currentThumb);
      }
    }

    /**
     * Stub for variant-picker calls. Listening to change event instead.
     */
    // eslint-disable-next-line class-methods-use-this
    setActiveMedia() {}

    /**
     * Sets the active media item.
     * @param {Element} mediaItem - Media element to set as active.
     * @param {boolean} [scrollToItem=true] - Scroll to the active media item.
     */
    customSetActiveMedia(mediaItem, scrollToItem = true) {
      if (mediaItem === this.currentItem) return;
      window.pauseAllMedia(this);
      this.currentItem = mediaItem;
      this.currentIndex = this.visibleItems.indexOf(this.currentItem);

      if (this.dataset.layout === 'stacked' && theme.mediaMatches.md) {
        // Update the active class and scroll to the active media
        if (this.stackedUnderline) {
          if (this.previousMediaItem) this.previousMediaItem.classList.remove('is-active');
          mediaItem.classList.add('is-active');
          this.previousMediaItem = mediaItem;
        }

        if (this.stackedScroll !== 'never') {
          const y = mediaItem.getBoundingClientRect().top
            + document.documentElement.scrollTop - 150;

          // If the element is far enough away to scroll to it
          if (Math.abs(y - document.documentElement.scrollTop) > 300) {
            window.scrollTo({
              top: y < 100 ? 0 : y,
              behavior: 'smooth'
            });
          }
        }
        return;
      }

      if (this.currentItem != null) {
        if (scrollToItem) this.viewer.scrollTo({ left: this.currentItem.offsetLeft });
      }
      if (this.thumbs) this.setActiveThumb();

      if (this.controls) {
        if (theme.mediaMatches.sm) {
          if (this.prevBtn) {
            this.prevBtn.disabled = this.currentIndex === 0;
          }

          if (this.nextBtn) {
            this.nextBtn.disabled = this.currentIndex === this.visibleItems.length - 1;
          }
        }

        if (this.counterCurrent) {
          const nonCloneItems = this.visibleItems.filter(item => !item.classList.contains('media-viewer__item--clone'));
          const realIndex = nonCloneItems.indexOf(this.currentItem);
          this.counterCurrent.textContent = realIndex >= 0 ? realIndex + 1 : 1;
        }
      }

      if (this.currentItem != null) {
        this.announceLiveRegion(this.currentItem, this.currentIndex + 1);
      }

      if (this.xrButton && mediaItem.dataset.mediaType === 'model') {
        this.xrButton.dataset.shopifyModel3dId = mediaItem.dataset.mediaId;
      }
    }

    /**
     * Sets the active thumbnail.
     */
    setActiveThumb() {
      if (this.currentItem != null) {
        this.currentThumb = this.thumbs.querySelector(
          `[data-media-id="${this.currentItem.dataset.mediaId}"][data-product-id="${this.currentItem.dataset.productId}"]`
        );
      }
      const btn = this.currentThumb.querySelector('button');

      this.thumbs.querySelectorAll('.media-thumbs__btn').forEach((el) => {
        el.classList.remove('is-active');
        el.removeAttribute('aria-current');
      });

      btn.classList.add('is-active');
      btn.setAttribute('aria-current', 'true');
      this.checkThumbVisibilty(this.currentThumb);
    }

    /**
     * Creates an array of the visible media items.
     */
    setVisibleItems() {
      this.viewerItems = this.querySelectorAll('.media-viewer__item');
      this.visibleItems = Array.from(this.viewerItems).filter((el) => el.clientWidth > 0);
      if (this.counterTotal) {
        this.counterTotal.textContent = this.visibleItems.filter(item => !item.classList.contains('media-viewer__item--clone')).length;
      }
    }

    setVisibleThumbsItems() {
      this.thumbsItems = this.querySelectorAll('.media-thumbs__item');
      this.visibleThumbsItems = Array.from(this.thumbsItems).filter((el) => el.clientHeight > 0);
    }

    /**
     * Ensures a thumbnail is in the visible area of the slider.
     * @param {Element} thumb - Thumb item element.
     */
    checkThumbVisibilty(thumb) {
      if (this.thumbs.closest('.media-gallery').classList.contains('thumbs-bottom')) {
        const scrollPos = this.thumbs.scrollLeft;
        const lastVisibleThumbOffset = this.thumbs.clientWidth + scrollPos;
        const thumbOffset = thumb.offsetLeft;

        if (thumbOffset + thumb.clientHeight > lastVisibleThumbOffset || thumbOffset < scrollPos) {
          this.thumbs.scrollTo({ left: thumbOffset, behavior: 'smooth' });
        }
      } else {
        const scrollPos = this.thumbs.scrollTop;
        const lastVisibleThumbOffset = this.thumbs.clientHeight + scrollPos;
        const thumbOffset = thumb.offsetTop;

        if (thumbOffset + thumb.clientHeight > lastVisibleThumbOffset || thumbOffset < scrollPos) {
          this.thumbs.scrollTo({ top: thumbOffset, behavior: 'smooth' });
        }
      }
    }

    /**
     * Updates the media gallery status.
     * @param {Element} mediaItem - Active media element.
     * @param {number} index - Active media index.
     */
    announceLiveRegion(mediaItem, index) {
      const image = mediaItem.querySelector('.media-viewer img');
      if (!image) return;

      this.liveRegion.setAttribute('aria-hidden', 'false');
      this.liveRegion.innerHTML = theme.strings.imageAvailable.replace('[index]', index);

      setTimeout(() => {
        this.liveRegion.setAttribute('aria-hidden', 'true');
      }, 2000);
    }

    setThumbsHeight() {
      this.thumbs.style.maxHeight = window.matchMedia(theme.mediaQueries.md).matches ? this.viewer.offsetHeight + 'px' : '';
    }

    /**
     * Loads the deferred media for the active item.
     * @param {Element} mediaItem - Active media element.
     */
    static playActiveMedia(mediaItem) {
      window.pauseAllMedia();
      const deferredMedia = mediaItem.querySelector('deferred-media');
      if (deferredMedia) deferredMedia.loadContent();
    }

    /** Lazy-load sibling product image */
    loadSiblingMediaInBackground() {
      const lazyItems = this.querySelectorAll('.media-viewer__item--js-lazy');

      if (!lazyItems.length) return;

      lazyItems.forEach(item => {
        if (item.dataset.hydrated) return;

        const src = item.dataset.imageSrc;
        const srcSet = item.dataset.imageSrcset || '';
        const previewSrc = item.dataset.imagePreview || src;
        const alt = item.dataset.imageAlt || '';
        if (!src) return;

        const picture = item.querySelector('picture');
        const zoomImg = item.querySelector('.js-zoom-image');
        const zoomLink = item.querySelector('.js-zoom-link');
        if (!picture || !zoomImg) return;

        picture.innerHTML = `
           <source
              data-srcset="${previewSrc} 690w, ${src} 800w"
              media="(max-width: 600px)"
              width="800"
              height="auto"
            >
            <img
              class="product-image img-fit img-fit--contain w-full no-js-hidden"
              src="${previewSrc}"
              data-src="${src}"
              data-srcset="${srcSet}"
              loading="lazy"
              decoding="async"
              alt="${alt}"
            >
        `;

        zoomImg.src = src;
        zoomLink.addEventListener('mousemove', this.zoomEventListener);
        zoomLink.classList.remove('pointer-events-none');

        item.dataset.hydrated = 'true';
      });
    }
  }

  customElements.define('media-gallery', MediaGallery);
}
